import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@repo/ui/utils.ts";
import { PortableText, type PortableTextReactComponents } from "next-sanity";
import { asPortableText, hardBreakHandler, onMissingPortableTextComponent, proseBaseClasses } from "./shared";

/**
 * Dedicated component for the `richTextDescription` schema.
 *
 * Schema permits: `normal` blocks only — no marks, no lists, no annotations.
 * Effectively plain text with line breaks, used for short descriptive copy.
 */
const components: Partial<PortableTextReactComponents> = {
  hardBreak: hardBreakHandler
};
interface RichTextDescriptionProps<T = unknown> {
  richText?: T | null;
  className?: string;
  compact?: boolean;
}
export function RichTextDescription(t0) {
  const $ = _c(10);
  const {
    richText,
    className,
    compact
  } = t0;
  if (!richText) {
    return null;
  }
  const t1 = compact && "[&>p]:m-0";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn(proseBaseClasses, "typography-body-sm-regular text-text-secondary", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== richText) {
    t3 = asPortableText(richText);
    $[3] = richText;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <PortableText value={t3} components={components} onMissingComponent={onMissingPortableTextComponent} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}